/**
 * Resolve DT_VITE_* config for deployed SPAs.
 *
 * Vite inlines `import.meta.env.DT_VITE_*` at **build** time, so a `dev-*` image
 * baked with `dt-api.dev.fairgen.ai` would keep calling DEV from QA/prod.
 * The dt-frontend chart writes pod env into `/runtime-env.js` as
 * `window.__RUNTIME_ENV__` at container start — prefer that overlay so one image
 * can run in every environment.
 */

export function getRuntimeEnv(): Record<string, string> {
  if (typeof window === 'undefined') return {};
  return (
    (
      window as unknown as { __RUNTIME_ENV__?: Record<string, string> }
    ).__RUNTIME_ENV__ ?? {}
  );
}

/** Runtime (K8s) wins over Vite bake-in; empty/whitespace is treated as unset. */
export function getDtVite(key: string): string | undefined {
  const fromRuntime = getRuntimeEnv()[key];
  if (typeof fromRuntime === 'string' && fromRuntime.trim()) {
    return fromRuntime.trim();
  }
  const fromVite = (import.meta.env as Record<string, unknown>)[key];
  if (typeof fromVite === 'string' && fromVite.trim()) {
    return fromVite.trim();
  }
  return undefined;
}

/**
 * Backend API base for axios / fetch.
 * Default `/api` matches local Vite proxy and same-origin nginx.
 */
export function getApiBaseUrl(): string {
  return getDtVite('DT_VITE_API_URL') || '/api';
}
